import { useFormField } from '@calendly/form'
import { PhoneField } from '@calendly/telephone-tools'
import { useCallback } from 'react'

// @calendly/form's PhoneField shows meta.error the instant validation fails, with no touched gate
// (unlike TextField/NumberField's errorOnInputOnly). Gate on meta.touched ourselves instead, same
// as slug-field.js, so the "required" error only appears after the user leaves the field.
export const PhoneNumberField = ({ name, label, countryCode, numberFormat, required }) => {
  const [{ value, onChange: fieldOnChange }, meta, { setTouched }] = useFormField({ name })

  const handleChange = useCallback((itiValue) => {
    fieldOnChange(itiValue.value)
  }, [fieldOnChange])

  const handleBlur = useCallback(() => {
    setTouched(true)
  }, [setTouched])

  return (
    <PhoneField
      name={name}
      label={label}
      countryCode={countryCode}
      numberFormat={numberFormat}
      required={required}
      number={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={meta.touched ? meta.error : undefined}
    />
  )
}
